import { Toaster as SonnerToaster } from "sonner";

export function Toaster() {
  return (
    <SonnerToaster
      position="top-center"
      toastOptions={{
        classNames: {
          toast:
            "rounded-lg border border-slate-200 bg-white text-slate-900 shadow-sm dark:border-slate-800 dark:bg-slate-950 dark:text-slate-50",
          description: "text-slate-600 dark:text-slate-400",
          actionButton: "bg-amber-500 text-slate-950",
          cancelButton: "bg-slate-100 text-slate-900 dark:bg-slate-900 dark:text-slate-50"
        }
      }}
    />
  );
}

